import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Card, CardContent } from '@/components/ui/card';

const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleString();
  } catch {
    return dateStr;
  }
};

const CustomDashboardCard = ({ name, count, unit = '' }) => (
  <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform">
    <div className="border border-border px-2 py-2 rounded-[16px] bg-background">
      <div className="space-y-1">
        <div className="text-xs font-medium text-muted-foreground">{name}</div>
        <div className="text-xs font-normal break-all">
          {count !== null && count !== undefined && count !== '' ? count : 'N/A'} {unit}
        </div>
      </div>
    </div>
  </div>
);

const ViewRakeMovementDialog = ({ open, onOpenChange, rakeData }) => {
  if (!rakeData) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Rake Trip Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <CustomDashboardCard name="Trip Number" count={rakeData.trip_number} />
            <CustomDashboardCard name="Transporter" count={rakeData.transporter_name} />
            <CustomDashboardCard name="RR Number" count={rakeData.rr_number} />
            <CustomDashboardCard name="RR Date" count={formatDate(rakeData.rr_date)} />
            <CustomDashboardCard name="Baseline Quantity" count={rakeData.baseline_qty_mt !== null && rakeData.baseline_qty_mt !== undefined ? rakeData.baseline_qty_mt : 'N/A'} unit={rakeData.baseline_qty_mt !== null && rakeData.baseline_qty_mt !== undefined ? 'MT' : ''} />
            <CustomDashboardCard name="Total Dispatched Quantity" count={rakeData.total_dispatched_qty_mt} unit="MT" />
          </div>

          <Card className="border border-border rounded-[16px] bg-card w-full">
            <CardContent className="p-0">
              <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform">
                <div className="border border-border px-2 py-2 rounded-[16px] bg-background">
                  <h3 className="text-xs font-bold text-foreground mb-3">Location & Terminal Details</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <CustomDashboardCard
                      name="Port"
                      count={
                        rakeData.port
                          ? `${rakeData.port.port_name || rakeData.port.name || 'N/A'}${
                              rakeData.port.port_code ? ` (${rakeData.port.port_code})` : ''
                            }`
                          : 'N/A'
                      }
                    />
                    <CustomDashboardCard
                      name="State / District"
                      count={`${rakeData.state?.name || 'N/A'} / ${rakeData.district?.name || 'N/A'}`}
                    />
                    <CustomDashboardCard
                      name="Rake Point Terminal"
                      count={
                        rakeData.rake_point
                          ? `${rakeData.rake_point.name || 'N/A'}${
                              rakeData.rake_point.code ? ` (${rakeData.rake_point.code})` : ''
                            }`
                          : 'N/A'
                      }
                    />
                    {rakeData.buffer_godown_rake_point && (
                      <CustomDashboardCard
                        name="Buffer Godown"
                        count={rakeData.buffer_godown_rake_point.name}
                      />
                    )}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-border rounded-[16px] bg-card w-full">
            <CardContent className="p-0">
              <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform">
                <div className="border border-border px-2 py-2 rounded-[16px] bg-background">
                  <h3 className="text-xs font-bold text-foreground mb-3">Schedule Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <CustomDashboardCard name="Scheduled Start Time" count={formatDate(rakeData.scheduled_start_time)} />
                    <CustomDashboardCard name="Scheduled End Time" count={formatDate(rakeData.scheduled_end_time)} />
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-border rounded-[16px] bg-card w-full">
            <CardContent className="p-0">
              <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform">
                <div className="border border-border px-2 py-2 rounded-[16px] bg-background">
                  <h3 className="text-xs font-bold text-foreground mb-3">Product Items</h3>
                  {rakeData.items && rakeData.items.length > 0 ? (
                    <div className="space-y-2">
                      {rakeData.items.map((item, idx) => (
                        <div key={idx} className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <CustomDashboardCard
                            name={`Product #${idx + 1}`}
                            count={item.product_type?.name || item.product_type_id}
                          />
                          <CustomDashboardCard
                            name="Quantity"
                            count={item.quantity_mt}
                            unit="MT"
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-xs text-muted-foreground">No items available</div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewRakeMovementDialog;
